import store from '@/core/store'

class FiltersHandler {
  /**
   * config: {
   *  scope: 'threads' | 'activities' | 'contacts'
   *  fetchDataFromAPI: (filter) => { await threadsService
   *    .queryLastThreadsByFilter({
   *      type: filter.type,
   *      value: filter.value
   *    }, page)
   *  },
   *  storeHandlers: {
   *    setFilter: Store.setFilter,
   *    getFilter: Store.getFilter,
   *    setLoadingStatus: Store.setLoadingStatus,
   *    setPages: Store.setPages,
   *    getCurrentFilterPage: Store.getCurrentFilterPage,
   *    setPaginationDataForCurrentFilter: Store.setPaginationDataForCurrentFilter,
   *  },
   *  filterProcessor?: {},
   *  events : {
   *    localFetch: 'THREADS:filtered',
   *    afterAPIFetch: 'THREADS:filtered',
   *  },
   * }
   *
  */
  constructor ({ scope, fetchDataFromAPI, storeHandlers, filterProcessor, events }) {
    this.scope = scope
    this.fetchDataFromAPI = fetchDataFromAPI
    this.storeHandlers = storeHandlers
    this.processFilterHandler = filterProcessor
    this.events = events
  }

  buildFilter (type, value, label, altValue = value) {
    return {
      type, value, label, scope: this.scope, altValue,
    }
  }
  
  async applyFilterFor (filterType, filterName, filterValue, forceFetch = false) {
    const filter = this.buildFilter(filterType, filterValue, filterName, this.scope)
    await this.applyFilter(filter, 0, forceFetch)
  }

  async applyFilter (filter, page = 0, forceFetch = false) {
    this.storeHandlers.setFilter(filter)
    this.triggerLocalFetchFiltering(filter)

    if (!this.filterPageExistsForPageNumber(filter, page) || forceFetch) {
      const data = await this.handleDataFetch(filter, page)
      this.triggerAfterAPIFetchFiltering(filter)
      if (data) {
        this.storeHandlers.setPaginationDataForCurrentFilter(page, data)
        return data
      }
    }
  }

  triggerLocalFetchFiltering (filter) {
    store.commit(this.events.localFetch, this.processFilterHandler(filter))
  }

  triggerAfterAPIFetchFiltering (filter) {
    store.commit(this.events.afterAPIFetch, this.processFilterHandler(filter))
  }

  filterPageExistsForPageNumber (filter, page) {
    return this.storeHandlers.getFilterPageForFilter(filter)?.page >= page
  }

  async handleDataFetch (filter, page = 0) {
    try {
      this.storeHandlers.setLoadingStatus(true)
      const data = await this.fetchDataFromAPI(filter, page)
      this.storeHandlers.setLoadingStatus(false)
      return data
    } catch {
      this.storeHandlers.setLoadingStatus(false)
      return {}
    }
  }
}

export default FiltersHandler
